import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPaymentList as getPaymentListApi,
	getPayment as getPaymentApi,
	addNewPayment as addNewPaymentApi,
	updatePayment as updatePaymentApi,
	deletePayment as deletePaymentApi,
	setPaymentCancelled as setPaymentCancelledApi,
	generatePayment as generatePaymentApi,
	previewPayment as previewPaymentApi,
	calculateModuleUsageFact as calculateModuleUsageFactApi,
} from '../../helpers/settings/backend_helper';

export const getPaymentList = createAsyncThunk(
	'payments/getPaymentList',
	async () => {
		try {
			const response = getPaymentListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getPayment = createAsyncThunk(
	'payments/getPayment',
	async payment_id => {
		try {
			const response = getPaymentApi(payment_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const setPaymentCancelled = createAsyncThunk(
	'payments/setPaymentCancelled',
	async payment_id => {
		try {
			const response = setPaymentCancelledApi(payment_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewPayment = createAsyncThunk(
	'payments/addNewPayment',
	async payment => {
		try {
			const response = addNewPaymentApi(payment);
			toast.success('Payment agregado exitosamente.', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al agregar payment.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updatePayment = createAsyncThunk(
	'payments/updatePayment',
	async payment => {
		try {
			const response = updatePaymentApi(payment);
			toast.success('Payment actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar payment.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deletePayment = createAsyncThunk(
	'payments/deletePayment',
	async payment => {
		try {
			const response = await deletePaymentApi(payment);
			toast.success('Payment eliminado exitosamente.', { autoClose: 3000 });
			return { payment, ...response };
		} catch (error) {
			toast.error('Error al eliminar payment.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const generatePayment = createAsyncThunk(
	'payments/generatePayment',
	async ({ month, year, category = 'REGULAR' }, thunkAPI) => {
		try {
			const response = await generatePaymentApi({ month, year, category });
			toast.success('Pagos generados exitosamente.', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al generar pagos.', { autoClose: 3000 });
			return thunkAPI.rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const calculateModuleUsageFact = createAsyncThunk(
	'payments/calculateModuleUsageFact',
	async ({ year, month }, thunkAPI) => {
		try {
			const response = await calculateModuleUsageFactApi({ year, month });
			return response;
		} catch (error) {
			toast.error('Error al calcular hechos de uso.', { autoClose: 3000 });
			return thunkAPI.rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const previewPayment = createAsyncThunk(
	'payments/previewPayment',
	async ({ year, month, category = 'REGULAR' }, thunkAPI) => {
		try {
			const response = await previewPaymentApi({ year, month, category });
			return response;
		} catch (error) {
			toast.error('Error al previsualizar pagos.', { autoClose: 3000 });
			return thunkAPI.rejectWithValue(error.response?.data || error.message);
		}
	}
);
